import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Card} from 'react-bootstrap';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';


import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import RenderSiswaReset from './RenderSiswaReset';


import response from './response.json';

class ResetDurasiAndPengerjaan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,            
            resMessage: '',
            ta: [],
            kelas: [],
            KelasParalelSearch: [],
            jadwalCbt: [],
            listSiswa: []
            
        }
    }

    async componentDidMount(){
        this.setState({isFetching: true});
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {            
            this.fetchTa();
            this.fetchKelas();            
        } 
        this.setState({
            // listSiswa: response.data
        })
        this.setState({isFetching: false});
    }

    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })
        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
            }
        }       

        resTa.data.data.map((val) =>{
            if(val.status == "1"){
                this.setState({kodeTa:val.kodeTahunAjaran})
                this.setState(prevState => {
                    let kuota = Object.assign({}, prevState.kuota);
                    kuota['tahunAjaran'] = val.kodeTahunAjaran;
                    return { kuota };
                })
            }
        })
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        let kodeJenjang = null;
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                kodeJenjang = resSekolah.data.data.kodeJenjangSekolah;               
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: kodeJenjang}).catch(function(error){
        });
        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChange = async (e) =>{
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });

        switch (name) {
            case 'idKelas':
                    this.fetchKelasParalel(value);
                break;

            case 'idKp':
                    this.setState({
                        kodeTipe: '',
                        jadwalCbt: [],
                        idJadwal:''
                    })
                break;

            case 'kodeTipe':
                    this.setState({
                        jadwalCbt: [],
                        idJadwal:''
                    })
                    this.fetchJadwal(value)
                break;

            case 'idJadwal':
                this.fetchSiswa(value)
                break;
            default:
                break;
        }
    }

    fetchKelasParalel  = async (idKelas) => {
        this.setState({
            isFetching: true,
            KelasParalelSearch: [],
            kodeTipe: '',
            jadwalCbt: [],
            idJadwal:''
        })
        
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }

        this.setState({isFetching: false});
    }

    fetchJadwal  = async (kodeTipe) => {
        this.setState({
            isFetching: true,
            jadwalCbt: [],
            idJadwal:''
        })
        
        const response = await accountManagement.get(CONFIG.REPORT_CBT_GET_JADWAL, {
            params: { 
                tahunAjaran: this.state.kodeTa, 
                idSekolah: this.props.account.idSekolah,
                idKelas: this.state.idKelas,
                tipeCbt: kodeTipe
            }
        }).catch (function(error){ console.log(error)}) 

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwalCbt: response.data.data
                })
            }
        }

        this.setState({isFetching: false});
    }

    refreshListSiswa = async (e) =>{
        this.setState({
            // listSiswa: [],
        })
        
        const response = await accountManagement.get(CONFIG.REPORT_CBT_LIST_SISWA, {
            params: { 
                tahunAjaran: this.state.kodeTa, 
                idJadwalCbt: this.state.idJadwal,
                idKelasParalel: this.state.idKp
            }
        }).catch(function(error){});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listSiswa: response.data.data
                })
            }
        }
    }

    fetchSiswa  = async (idJadwal) => {
        this.setState({
            isFetching: true,
            listSiswa: [],
        })
        
        const response = await accountManagement.get(CONFIG.REPORT_CBT_LIST_SISWA, {
            params: { 
                tahunAjaran: this.state.kodeTa, 
                idJadwalCbt: idJadwal,
                idKelasParalel: this.state.idKp
            }
        }).catch(function(error){});
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listSiswa: response.data.data
                })
            }
        }
        this.setState({ isFetching: false })
    }
    componentDidUpdate(){
        console.clear();
        // console.log(this.state)
    }


    render() { 
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title="Reset Durasi / Status Pengerjaan"/>
                    {this.loadAlert()}
                    <Row>
                        {/* ================ COLOM KIRI ================ */}
                        <Col>
                            <Col>
                                <select className="form-control" name="kodeTa" value={this.state.kodeTa} onChange={this.handleOnChange} required>
                                    <option key="key" value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                    <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                </select>
                            </Col>
                            <Col style={{marginTop:'10px'}}>
                                <select className="form-control" name="idKelas" value={this.state.idKelas} onChange={this.handleOnChange} required>
                                    <option key="key" value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>
                            <Col style={{marginTop:'10px'}}>
                                <select className="form-control" name="idKp" value={this.state.idKp} onChange={this.handleOnChange}>
                                    <option value="" selected>~~ Pilih Kelas Paralel ~~</option>
                                    <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                </select>
                            </Col>
                        </Col>

                        
                        {/* ================ COLOM KANAN ================ */}
                        <Col>
                            <Col>
                                <select className="form-control" name="kodeTipe" value={this.state.kodeTipe} onChange={this.handleOnChange} required>
                                    <option key="key" value="" selected disabled>~~ Pilih Tipe Test ~~</option>
                                    <option key="TOO" value="TOO">TOO</option>
                                    <option key="AGCU" value="AGCU">AGCU</option>
                                    <option key="ASM" value="ASM">ASM</option>
                                    <option key="PEMINATAN" value="PEMINATAN">PEMINATAN</option>
                                </select>
                            </Col>
                            <Col style={{marginTop:'10px'}}>
                                <select className="form-control" name="idJadwal" value={this.state.idJadwal} onChange={this.handleOnChange} required>
                                    <option key="key" value="" selected disabled>~~ Pilih CBT ~~</option>
                                    {this.state.jadwalCbt.map(jadwal => 
                                        <option key={jadwal.idJadwalCbt} value={jadwal.idJadwalCbt}>{jadwal.namaJadwalCbt}</option>
                                    )}
                                </select>
                            </Col> 
                        </Col>
                    </Row>

                    {!__.isEmpty(this.state.listSiswa) &&
                        <RenderSiswaReset 
                                            listSiswa={this.state.listSiswa}
                                            idJadwal={this.state.idJadwal}
                                            kodeTipe={this.state.kodeTipe} 
                                            refreshListSiswa={this.refreshListSiswa}/>
                    }
                    

                </div>
            </div>
        );
    }

    
    loading = () =>{
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }
    
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        } 
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}
export default connect(mapStateToProps, {cekCookies})(ResetDurasiAndPengerjaan);